import AuthContext from "../store/AuthContext";
import { useContext, useState } from "react";
import { twMerge } from "tailwind-merge";

import FieldGroup from "./FieldGroup";

import "react-toastify/dist/ReactToastify.css";

import { useLazyGetPortalLinkQuery } from "../store/api";
import { useSelector } from "react-redux";

import PortalLink from "./PortalLink";

const AddCard = (props) => {
  const { onAdd } = props;

  const authctx = useContext(AuthContext);

  const { setOverlay } = authctx;

  const { deal, stripeCustomer } = useSelector((state) => state.cashier);

  const [paymentLink, setPaymentLink] = useState(null);

  const [requestPortalLink] = useLazyGetPortalLinkQuery();

  const getPortalLink = async (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    setOverlay("Getting customer link…");

    const result = await requestPortalLink(
      { customerId: stripeCustomer.id },
      false,
    ).unwrap();

    setPaymentLink(() => result);
    setOverlay("");
  };

  return (
    <FieldGroup className="mb-4 content-center">
      <button
        className="my-2 w-full bg-blue-400 p-2 font-semibold text-white"
        onClick={onAdd}
      >
        Add card
      </button>
      <div
        className={twMerge(
          "",
          paymentLink && "rounded border border-black p-2",
        )}
      >
        <button
          className="my-2 w-full bg-gray-400 p-2 font-semibold text-white"
          onClick={getPortalLink}
        >
          Customer link to update payment info
        </button>
        {paymentLink && (
          <PortalLink
            customer={stripeCustomer}
            deal={deal}
            link={paymentLink}
            onClose={() => setPaymentLink(() => null)}
          />
        )}
      </div>
    </FieldGroup>
  );
};
export default AddCard;
